// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_hv","advertCardPhoto__image":"c-a_hw"};